export default __webpack_public_path__ + "static/media/defaultBrand.d50e51ec.png";